import React from 'react';
import { useIntl } from 'react-intl';

import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

import SignInBtn from './SignInBtn.js';

function DefaultSignIn(props) {
  const intl = useIntl();
  const { classes, signInWithGoogle, signInWithApple, goSignInWithEmailPage, backgroundImage } = props;

  const sign_in_same_account = intl.formatMessage({
    id: 'sign_in_same_account',
  });
  return (
    <div className={classes.signInScreen} style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className={classes.mainArea}>
        <div className={classes.textArea}>
          <h2 className={classes.headerText}>
            <span className={classes.heading}>
              <FormattedMessage id="ldpage_heading_title" />
            </span>
          </h2>
          <div
            className={classes.subHeading}
            dangerouslySetInnerHTML={{ __html: sign_in_same_account }}
          ></div>
          <div id="signInArea" className={classes.signInArea}>
            <div className={classes.signInBtn} onClick={(event) => signInWithGoogle()}>
              <SignInBtn type="google" />
            </div>
            <div className={classes.signInBtn} onClick={(event) => goSignInWithEmailPage()}>
              <SignInBtn type="email" />
            </div>
            <div className={classes.signInBtn} onClick={(event) => signInWithApple()}>
              <SignInBtn type="apple" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = (theme) => ({
  signInScreen: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    backgroundSize: 'cover',
    fontFamily: 'Open Sans',
    minHeight: 660,
  },
  mainArea: {
    width: '100%',
    color: '#0b3669',
    height: 'calc( 100vh - 110px)',
  },
  heading: {
    fontFamily: 'Platform Web',
    fontSize: 43,
    fontWeight: 500,
    lineHeight: '53px',
    color: '#1a1a1a',
    whiteSpace: 'pre-line',
    width: 436
  },
  subHeading:{
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '17px',
    lineHeight: '24px',
    color: '#757575',
    marginTop: '8px',
    width: 436
  },
  textArea: {
    width: '50%',
    boxSizing: 'border-box',
    padding: '0 5%',
    textAlign: 'left',
    marginTop: 130,
    flexDirection: 'column'
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',
    userSelect: 'none',
    fontFamily: window.navigator.language.toLowerCase().indexOf('en') !== -1 ? 'Lato' : theme.typography.fontFamily,
    textAlign: 'left',
    width: '100%',
    margin: 0,
  },
  signInArea: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: 24,
  },
  signInBtn: {
    marginBottom: 16,
  },
  logoImg: {
    marginBottom: 10,
  },
  errorMessage: {
    fontFamily: 'Lato',
    display: 'none',
    color: '#f00',
    marginBottom: theme.spacing.unit,
    lineHeight: '150%',
  },
  hidden: {
    display: 'none',
  },
});

export default withStyles(styles)(DefaultSignIn);
